// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal, Button } from 'antd';

// @ts-ignore


class NotifModal extends React.Component {

  handleRedirect = () =>{
    this.props.isRedirected();
  };

  showScanFinger = () =>{
    this.props.showScan();
  };

  render() {
		const { isDisplay, hideModal } = this.props;

		return (
    <Row onClick={hideModal}>
      <Modal
        visible={isDisplay}
        maskClosable
        footer={<></>}
      >
       <Row justify="center">
            <Col>
              <h1> NO MATCH FOUND! </h1>
            </Col>
            <Row>
              <Col style={{marginRight: 5}}>
                <Button onClick={this.handleRedirect}>REGISTER</Button>
              </Col>
              <Col style={{marginLeft: 5}}>
                <Button onClick={this.showScanFinger}>SCAN AGAIN</Button>
              </Col>
            </Row>
          </Row>
      </Modal>
    </Row>
    );
  }
}

NotifModal.propTypes = {
  isDisplay: PropTypes.bool.isRequired,
  isRedirected: PropTypes.func,
  handleScan: PropTypes.func,
};

export default NotifModal;
